const unsafePropertyDamageReduction =
  'return acc + (isNaN(val.ApproxCostOfDamage) ? 0 : val.ApproxCostOfDamage);';
const safePropertyDamageReduction =
  'const amount = Number(val && val.ApproxCostOfDamage); return acc + (Number.isFinite(amount) ? amount : 0);';

export const applyFormSchemaFixes = (form: any): any => {
  const visited = new Set<any>();

  const visit = (value: any) => {
    if (!value || typeof value !== 'object' || visited.has(value)) {
      return;
    }

    visited.add(value);

    // EMS identifiers are text in transcription and may contain leading zeroes or letters.
    if (
      value.type === 'number' &&
      (value.key === 'EMSRunNumber' || value.key === 'NonMotoristEMSRunNumber')
    ) {
      value.type = 'textfield';
      value.inputType = 'text';
    }

    if (
      typeof value.calculateValue === 'string' &&
      value.calculateValue.includes('PropertyDamageEditGrid') &&
      value.calculateValue.includes('DamagedProperty.reduce') &&
      value.calculateValue.includes(unsafePropertyDamageReduction)
    ) {
      value.calculateValue = value.calculateValue.replace(
        unsafePropertyDamageReduction,
        safePropertyDamageReduction
      );
    }

    Object.keys(value).forEach(key => visit(value[key]));
  };

  visit(form);
  return form;
};
